import { pdfjs } from 'react-pdf';
 
const initializePdfJs = () => {
  pdfjs.GlobalWorkerOptions.workerSrc=`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
}
 
 export default initializePdfJs;


